import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import IconAdd from "@material-ui/icons/Add";

import Grid from "../../lib/components/grid";
import Confirmation from "../../lib/components/confirmation";
import { upsertEstimatedCostItemGroups, estimatedcostitemgroups } from "../../lib/api/estimatedcostitemgroups";

import { GridColumns } from "./estimatedcostitemgroupsgridsetup";
import EstimatedCostItemGroupsEditForm from "./estimatedcostitemgroupseditform";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      width: "100%",
      height: "100%",
    },
    inline: {
      display: "inline",
      position: "absolute",
      marginTop: "7px",
      marginLeft: "7px",
    },
  });

type EstimatedCostItemGroupsProps = {} & WithStyles<typeof styles>;

export class EstimatedCostItemGroupsUnstyled extends React.Component<EstimatedCostItemGroupsProps, any> {
  state = {
    classes: undefined,
    data: [],
    confirmRemoveID: undefined,
    confirmEditID: undefined,
    loading: true,
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    estimatedcostitemgroups.all().then((data) => {
      const dataSorted = data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 1;
      });
      this.setState({ loading: false, data: dataSorted });
    });
  };

  handleCreate = () => {
    this.setState({ confirmEditID: "0" });
  };

  handleEdit = (id) => {
    this.setState({ confirmEditID: id });
  };

  handleEditClose = () => {
    this.setState({ confirmEditID: undefined });
  };

  handleEditConfirm = async (e, item) => {
    e.preventDefault();

    const id = item["id"];
    delete item["id"];

    if (id == "0") {
      await upsertEstimatedCostItemGroups({ ...item });
      // estimatedcostitemgroups.create({ data: { ...item } }).then(() => this.loadData());
    } else {
      await upsertEstimatedCostItemGroups({ ...item, id });
      // estimatedcostitemgroups.update(id, { data: { ...item } }).then(() => this.loadData());
    }
    this.loadData();
    this.handleEditClose();
  };

  handleRemove = async (id) => {
    this.setState({ confirmRemoveID: id });
  };

  handleRemoveClose = () => {
    this.setState({ confirmRemoveID: undefined });
  };

  handleRemoveConfirm = async () => {
    await estimatedcostitemgroups.remove(this.state.confirmRemoveID).then(() => {
      this.handleRemoveClose();
      this.loadData();
    });
  };

  getCellActions = (column, row) => {
    return;
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.inline}>
          <Tooltip title="Create new Estimated Cost Item Group">
            <div className={classes.inline}>
              <Button variant="contained" color="primary" onClick={this.handleCreate} style={{ marginBottom: "10px" }}>
                <IconAdd />
              </Button>
            </div>
          </Tooltip>
        </div>
        <Grid
          loading={this.state.loading}
          data={this.state.data}
          GridColumns={(data, filters, arrangement, columnsWidth) => GridColumns(data, filters, arrangement, columnsWidth, this.handleEdit, this.handleRemove)}
          clearFilters={"estimatedcostitemgroupgridsetup"}
        />
        {this.state.confirmRemoveID && (
          <Confirmation
            isOpen={this.state.confirmRemoveID ? true : false}
            handleClose={this.handleRemoveClose}
            handleConfirm={this.handleRemoveConfirm}
            title="Remove selected Estimated Cost Item Group?"
            body="Are you sure you want to REMOVE the selected Estimated Cost Item Group Record?"
          ></Confirmation>
        )}
        {this.state.confirmEditID && (
          <Confirmation
            isOpen={this.state.confirmEditID ? true : false}
            handleClose={this.handleEditClose}
            handleConfirm={() => {}}
            title={this.state.confirmEditID == "0" ? "Creating Estimated Cost Item Group" : "Editing Estimated Cost Item Group"}
            body={undefined}
          >
            <EstimatedCostItemGroupsEditForm onSubmit={this.handleEditConfirm} onClose={this.handleEditClose} id={this.state.confirmEditID} />
          </Confirmation>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(EstimatedCostItemGroupsUnstyled);
